import React, { useState, memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, useMediaQuery, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { actions } from '../../../actions';
import { Close } from '@mui/icons-material';

const useStyles = () => {
  return makeStyles((theme) => ({
    close: {
      position: 'relative',
      right: -4,
      bottom: -16,
      // fontWeight: 'bold',
      fontSize: 18,
      color: theme.palette.gray.main,
      cursor: 'pointer',
      '&:hover': {
        color: theme.palette.gray.light,
      },
    },
  }));
};

const InputFilter = memo(() => {
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  const appDispatch = useDispatch();
  const filter = useSelector((state) => state.app.filter);
  const [value, setValue] = useState('');
  useEffect(() => {
    const keyword = filter.query.keyword.trim();
    setValue(keyword);
  }, []);
  function handleKeywordChange(value) {
    setValue(value);
    // only accept numbers and + symbol
    // if (value && !/^[\d+]+$/.test(value)) return;

    appDispatch({ type: actions.filterKeyword, keyword: value });

    // throthleDispatchKeyword(value);
  }

  return (
    <Box display="flex" alignItems="center" position="relative">
      <TextField
        label="Buscar por DNI/Tel"
        value={value}
        margin="normal"
        onChange={(event) => handleKeywordChange(event.target.value)}
        sx={{ minWidth: '200px' }}
      />
      {value && (
        <Box className={classes.close} onClick={() => handleKeywordChange('')}>
          <Close />
        </Box>
      )}
    </Box>
  );
});

export default InputFilter;
